import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFolderArrowUp16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFolderArrowUp16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.197 4H3.5a.5.5 0 0 0-.5.5V5h4.131l-.518-.777A.5.5 0 0 0 6.197 4M2 4.5V12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H8.333l-.888-1.332A1.5 1.5 0 0 0 6.197 3H3.5A1.5 1.5 0 0 0 2 4.5M7.798 6H12a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6zm1.966 3.604a.5.5 0 0 1-.708 0L8.5 9.047V11.5a.5.5 0 0 1-1 0V9.039l-.565.565a.5.5 0 1 1-.707-.708l1.414-1.414.354-.353.353.353 1.415 1.414a.5.5 0 0 1 0 .708"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFolderArrowUp16);
